import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_CONTENT_LINK_METADATA,
} from '../../../../actions/actionTypes';
import { getMetadataAsMap } from '../../../../helpers/dataHelper';

const contentLinkMetaData = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_CONTENT_LINK_METADATA
);

export default contentLinkMetaData;

export const getIncidentDetailsContentLinkMetaData = state =>
  getMetadataAsMap(state.response.data ?? [], 'modelName');
